import { supabaseClient } from 'supabase'
import { CampaignWithAdvertiser } from './types'

export async function getCampaigns(): Promise<CampaignWithAdvertiser[]> {
  const { data, error } = await supabaseClient
    .from('campaigns')
    .select(`
      *,
      advertisers (
        id,
        name,
        category,
        contact_email,
        logo_url
      )
    `)
    .order('created_at', { ascending: false })

  if (error) {
    console.error('Error fetching campaigns:', error)
    throw new Error(error.message)
  }

  return data as CampaignWithAdvertiser[]
}

export async function getCampaignById(id: string): Promise<CampaignWithAdvertiser> {
  const { data, error } = await supabaseClient
    .from('campaigns')
    .select(`
      *,
      advertisers (
        id,
        name,
        category,
        contact_email,
        logo_url
      )
    `)
    .eq('id', id)
    .single()

  if (error) {
    console.error('Error fetching campaign:', error)
    throw new Error(error.message)
  }

  if (!data) {
    throw new Error('Campaign not found')
  }

  return data as CampaignWithAdvertiser
}

export async function getCampaignDetail(id: string): Promise<CampaignWithAdvertiser & { campaign_creatives: any[] }> {
  // Fetch campaign with advertiser and creative assignments
  const { data, error } = await supabaseClient
    .from('campaigns')
    .select(`
      *,
      advertisers (
        id,
        name,
        category,
        contact_email,
        logo_url
      ),
      campaign_creatives (
        id,
        creative_id,
        created_at,
        creatives (
          id,
          title,
          description,
          title_pt,
          description_pt,
          card_image_url,
          detail_image_url,
          cta_text,
          cta_link,
          created_at
        )
      )
    `)
    .eq('id', id)
    .single()

  if (error) {
    console.error('Error fetching campaign detail:', error)
    throw new Error(error.message)
  }

  if (!data) {
    throw new Error('Campaign not found')
  }

  return data as CampaignWithAdvertiser & { campaign_creatives: any[] }
}